  <template>
  <div class="form-food">
    <!-- bisa dikasih attrb -->
    <h2 class="text-center" v-if="method === 'POST'">ADD FOOD</h2>
    <h2 class="text-center" v-if="method === 'PUT'">EDIT FOOD</h2>

    <form action="" method="POST" @submit.prevent="condition">
      <div class="mb-3">
        <label for="formGroupExampleInput" class="form-label">Name</label>
        <input
          type="text"
          class="form-control"
          name="name-add"
          id="name-add-food"
          v-model="name"
        />
      </div>
      <div class="mb-3">
        <label for="formGroupExampleInput2" class="form-label">Price</label>
        <input
          type="text"
          class="form-control"
          name="price-add"
          id="price-add-food"
          v-model="price"
        />
      </div>
      <div class="mb-3">
        <label for="formGroupExampleInput2" class="form-label"
          >Description</label
        >
        <input
          type="text"
          class="form-control"
          name="description-add"
          id="description-add-food"
          v-model="description"
        />
      </div>
      <div class="mb-3">
        <label for="category" class="form-label">Category</label><br />
        <select
          class="form-select"
          aria-label="Default select example"
          name="category-add"
          id="category-add-food"
          v-model="category"
        >
          <option
            v-for="categoryOpt in categoriesOpt"
            :key="categoryOpt.id"
            :value="categoryOpt.id"
          >
            {{ categoryOpt.name }}
          </option>
        </select>
      </div>
      <div class="mb-3">
        <label for="formGroupExampleInput2" class="form-label"
          >Upload Image</label
        ><br v-if="method === 'PUT'" />
        <img
          v-if="method === 'PUT'"
          :src="populateFood.imgUrl"
          width="150"
          alt=""
        />
        <input
          type="file"
          class="form-control"
          name="imgUrl-add"
          id="imgurl-add-food"
          v-on:change="onFileChange"
        />
      </div>
      <div class="button-sbmt">
        <Button
          class="btn btn-primary"
          buttonText="submitFood"
          type="submit"
        ></Button>
        <!-- <button type="submit" >Submit</button>   -->
      </div>
    </form>
    <button class="btn btn-primary" @click="toFoodList">Cancel</button>
  </div>
</template>
  <script>
import Button from "../components/button.vue";
import axios from "../apis/server";

export default {
  name: "Addfood",
  components: {
    Button,
  },
  props: ["method", "populateFood"],
  data() {
    return {
      name: "",
      price: "",
      description: "",
      category: "",
      categoriesOpt: "",
      imgUrl: "",
    };
  },
  methods: {
    onFileChange(e) {
      let files = e.target.files;
      this.imgUrl = files[0];
    },
    condition() {
      let form = new FormData();
      if (this.method === "POST") {
        form.append("name", this.name);
        form.append("description", this.description);
        form.append("price", this.price);
        form.append("imgUrl", this.imgUrl);
        form.append("categoryId", this.category);
        axios({
          url: "/foods",
          method: "POST",
          headers: { access_token: localStorage.getItem("access_token") },
          data: form,
        })
          .then(({ data }) => {
            this.$emit("toFoodList");
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Success add food",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((err) => {
            Swal.fire({
            title: "Error!",
            text: err.response.data[0],
            icon: "error",
            confirmButtonText: "Cool",
          });
          });
      } else if (this.method === "PUT") {
        form.append("name", this.name);
        form.append("description", this.description);
        form.append("price", this.price);
        form.append("imgUrl", this.imgUrl);
        form.append("categoryId", this.category);
        axios({
          url: `/foods/${this.populateFood.id}`,
          method: "PUT",
          headers: { access_token: localStorage.getItem("access_token") },
          data: form,
        })
          .then(({ data }) => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Food list updated",
              showConfirmButton: false,
              timer: 1500,
            });
            this.$emit("toFoodList");
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    toFoodList() {
      this.$emit("toFoodList");
    },
  },

  created() {
    if (this.method === "PUT") {
      this.name = this.populateFood.name;
      this.price = this.populateFood.price;
      this.description = this.populateFood.description;
      this.category = this.populateFood.categoryId;
    }
    axios({
      url: "/categories",
      method: "GET",
      headers: { access_token: localStorage.getItem("access_token") },
    })
      .then(({ data }) => {
        this.categoriesOpt = data;
      })
      .catch((err) => {
        /* TO BE SWAL */
        console.log(err);
      });
  },
};
</script>

  <style>
</style>